// Spanish labels for values the commercial tables store in English. The
// stored values do not change (filters, imports and Airtable keep using them);
// only what the screen shows is translated. Unknown values are shown as they are.
const LABELS = {
  // Contact status
  'Not Contacted': 'Sin contactar', 'Contacted': 'Contactado', 'Replied': 'Respondió', 'Meeting Booked': 'Reunión agendada',
  'Not Interested': 'No le interesa', 'DNC': 'No contactar', 'Bounced': 'Rebotó', 'Left Company': 'Dejó la empresa', 'Nurture': 'En seguimiento largo',
  // Influence and deal roles
  'Decision Maker': 'Decide', 'High': 'Alta', 'Medium': 'Media', 'Low': 'Baja', 'Influencer': 'Influye',
  'Champion': 'Promotor', 'Blocker': 'Bloquea', 'Economic Buyer': 'Decide la compra', 'Evaluator': 'Evalúa',
  // Sources
  'Outbound': 'Prospección', 'Inbound - Events': 'Entrante · eventos', 'Inbound - Paid Media': 'Entrante · publicidad',
  'Inbound - Referral': 'Entrante · recomendación', 'Inbound - Website': 'Entrante · web', 'Inbound - Direct': 'Entrante · directo',
  // Outreach status and direction
  'Sent': 'Enviado', 'Received': 'Recibido', 'Draft': 'Borrador', 'Opened': 'Abierto', 'Scheduled': 'Programado', 'Meeting Scheduled': 'Reunión agendada',
  'Inbound': 'Recibido', 'Outbound ': 'Enviado', 'No Reply': 'Sin respuesta',
  // Channels
  'Call': 'Llamada', 'Meeting': 'Reunión', 'In-person': 'En persona', 'Other': 'Otro',
  // Account status
  'Active Outreach': 'En contacto', 'Qualified': 'Calificada', 'Proposal Sent': 'Propuesta enviada', 'Negotiation': 'Negociación', 'On Hold': 'En pausa', 'Dormant': 'Dormida',
  'Active': 'Activa', 'Inactive': 'Inactiva', 'Lost': 'Perdida', 'Won': 'Ganada', 'Prospect': 'Prospecto',
  // Opportunity stages
  'Discovery': 'Descubrimiento', 'Proposal': 'Propuesta', 'Closed Won': 'Ganada', 'Closed Lost': 'Perdida', 'Unknown': 'Sin etapa',
};

/** The Spanish label of a stored value (the value itself when there is none). */
export const es = (v) => (v == null || v === '' ? v : LABELS[v] || v);
